import React, { useState, useEffect, useRef } from "react";
import "../css/ValidationModification.css";
import { useAuth } from "../AuthContext";
import { fetchModifications, rejeterModification, validerModification } from "./Fonctions_Communications_API";



export default function ValidationModification() {
  const { isAdmin } = useAuth();
  const [modificationsEffectuées, setModificationsEffectuées] = useState([]);
  const [etablissementChoisi, setEtablissementChoisi] = useState(null);


   const listRef = useRef(null);
   const itemRefs = useRef({});

   const handleSelection = (modification) => {
    
    setEtablissementChoisi((prev) =>
      prev?.numero_finess === modification.numero_finess ? null : modification
    );
  };

  const [besoinRefresh, setBesoinRefresh] = useState(false);

  useEffect(() => {
    if (isAdmin) {
      fetchModifications((data) => {
        const filteredModifications = data.filter(modification => !modification.validée);
        setModificationsEffectuées(filteredModifications);
      });
    }
  }, [isAdmin, besoinRefresh]);

  console.log(modificationsEffectuées)

  const comparerValeurs = (ancienne, nouvelle) => {
    return ancienne !== nouvelle ? "modifie" : "";
  };
  return (
    <div className="validation-container">
      {!isAdmin ? (
        <div className="not-allowed">
          <h2>Accès Refusé</h2>
          <p>
            Vous ne pouvez accéder à cette page sans entrer votre jeton de connexion sur l'
            <a href="https://carto.toobib.org" className="lien-caché-application">application</a>
          </p>
        </div>
      ) : (
      <div className="conteneur_global" style={{ display: "flex", width: "100vw", height: "100vh" }}>
        <div className="fenetre-validation-modifications">
          
          <div className={`fenetre ${etablissementChoisi ? "fenetre-active" : "fenetre-inactive"}`}>
            
            
              <div className="fenetre-titre">
                <h3>Anciennes valeurs</h3> 
              </div>
              <div className="fenetre-contenu">
              <ul>
                {Object.keys(etablissementChoisi?.anciennes_valeurs_finess || {}).map((cle) => (
                  <li key={cle} className={`${comparerValeurs(etablissementChoisi?.anciennes_valeurs_finess?.[cle], etablissementChoisi?.modification?.[cle])} ancienne_valeur`}>
                  <strong>{cle.replace(/_/g, " ")} :</strong> {
                    typeof etablissementChoisi?.anciennes_valeurs_finess?.[cle] === "boolean"
                      ? etablissementChoisi?.anciennes_valeurs_finess?.[cle] ? "Oui" : "Non"
                      : etablissementChoisi?.anciennes_valeurs_finess?.[cle]
                  }
                </li>
                ))}
              </ul>
              </div>
            
          
          </div>
          
          <div className={`fenetre ${etablissementChoisi ? "fenetre-active" : "fenetre-inactive"}`}>
            
          
            
            <div className="fenetre-titre">
              <h3>Nouvelles valeurs</h3> 
            </div>
            <div className="fenetre-contenu">
            <ul>
              {Object.keys(etablissementChoisi?.anciennes_valeurs_finess || {}).map((cle) => (
                <li key={cle} className={`${comparerValeurs(etablissementChoisi?.anciennes_valeurs_finess[cle], etablissementChoisi?.modification[cle])} nouvelle_valeur`}>
                <strong>{cle.replace(/_/g, " ")} :</strong> {
                  typeof etablissementChoisi?.modification[cle] === "boolean"
                    ? etablissementChoisi?.modification[cle] ? "Oui" : "Non"
                    : etablissementChoisi?.modification[cle]
                }
              </li>
              ))}
            </ul>
            </div>
            
          
          </div>
          
        </div>
        <div className="fenetre-validation-bouton-container">
            <button disabled={etablissementChoisi===null} onClick={()=>validerModification(etablissementChoisi.numero_finess, isAdmin,besoinRefresh, setBesoinRefresh, setEtablissementChoisi)} className="fenetre-validation-bouton">Valider les modifications</button>
            <button disabled={etablissementChoisi===null} onClick={()=>rejeterModification(etablissementChoisi.numero_finess, isAdmin,besoinRefresh, setBesoinRefresh, setEtablissementChoisi)} className="fenetre-validation-bouton">Refuser les modifications</button>
          </div>
        <div className="fenetre-validation-panneau">
        <div className="fenetre-validation-titre-panneau" >
            <h>Modifications non validées</h>
        </div>
        
        <div
      className="fenetre-validation-liste-de-resultats"
      ref={listRef}
      
    >
      {modificationsEffectuées.length > 0 ? (
        <ul>
        
      
        {modificationsEffectuées.map((modification) => (
        <li
          key={modification.numero_finess}
          id={`etablissement-${modification.numero_finess}`}
          className={`fenetre-validation-resultat ${
            etablissementChoisi?.numero_finess === modification.numero_finess ? "active" : ""
          }`}
          ref={(el) => (itemRefs.current[modification.numero_finess] = el)}
        >
          <button onClick={() => handleSelection(modification)}>
            <strong> {modification.modification.rs}</strong>
            <span className="numero-finess">
              {modification.modification.ville}
            </span>
            <span className="numero-finess-right">
              {modification.numero_finess}
            </span>
          </button>
        </li>
      ))}


      
      </ul>
      ) : (
        <p style={{ color: "white", fontSize: 15, marginTop: "30%", fontWeight: "bold" }}>
          Aucune modification en attente de validation
        </p>
      )}
    </div>
        </div>
      </div>

      )}
    </div>
  );
}
